<template>
  <q-page
    class="column no-wrap q-py-sm"
    style="max-height: calc(100vh - 150px)"
  >
    <table-configuration-provider
      :default-config="pageConfig.config"
      :default-columns="$options.DATA_TRACKING_EMAIL_COLUMNS"
      :filters="filters"
      class="column no-wrap col q-mx-sm"
      @saveConfig="onSaveConfig"
    >
      <template #default="props">
        <div class="col-auto q-px-sm row justify-end">
          <lwf-filters
            v-model="filters"
            :inline="$q.screen.gt.sm"
            :filters="$options.filtersOpt"
            :filters-preset="pageConfig.filtersPreset"
            position="top"
            :offset="[0, -24]"
            class="col-auto"
            @savePreset="onSaveFilterPreset"
          />
        </div>
        <table-tracking-emails
          :config="props.config"
          class="sticky-table col full-width column no-wrap"
        >
          <template #top-right>
            <table-configuration-provider-top-right :props="props" />
          </template>
        </table-tracking-emails>
      </template>
    </table-configuration-provider>
  </q-page>
</template>

<script>
import TableConfigurationProvider from 'components/Table/TableConfigurationProvider'
import LwfFilters from 'components/core/LwfFilters'
import TableConfigurationProviderTopRight from 'components/Table/TableConfigurationProviderTopRight'
import pagePersitantFilterMixin from '@/mixins/pagePersistantFilterMixin'
import {
  DATA_TRACKING_EMAIL_COLUMNS,
  DATA_TRACKING_EMAIL_EVENTS,
  DATA_TRACKING_EMAIL_PERSISTANCE_KEY
} from '@/consts/data/trackingEmails'
import TableTrackingEmails from 'components/Table/TableTrackingEmails'
import { FILTER_SELECT_TYPE } from '@/utils/filters'

export default {
  name: 'TrackingEmails',
  components: {
    TableTrackingEmails,
    TableConfigurationProviderTopRight,
    LwfFilters,
    TableConfigurationProvider
  },
  DATA_TRACKING_EMAIL_COLUMNS,
  DATA_TRACKING_EMAIL_EVENTS,
  PERSISTENCE_KEY: DATA_TRACKING_EMAIL_PERSISTANCE_KEY,
  filtersOpt: [
    'dateRange',
    {
      label: 'Évènement',
      key: 'event',
      props: {
        optionLabel: 'label',
        optionValue: 'value',
        options: DATA_TRACKING_EMAIL_EVENTS
      },
      options: {
        field: 'event',
        type: FILTER_SELECT_TYPE
      }
    }
  ],
  mixins: [pagePersitantFilterMixin],
  computed: {
    defaultConfig () {
      return {
        columns: DATA_TRACKING_EMAIL_COLUMNS.map((c) => c.name),
        pagination: {
          descending: true,
          sortBy: 'date'
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
